import styled from 'styled-components';

const MOBILE = '@media (max-width: 768px)';

export const Section = styled.section`
  padding: 6.4rem 0;

  ${MOBILE} {
    padding: 4rem 0;
  }
`;

export const Inner = styled.div`
  max-width: 108rem;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.lg};
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 3.2rem;

  ${MOBILE} {
    margin-bottom: 2rem;
  }
`;

export const Kicker = styled.div`
  display: inline-block;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.18rem;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.accent};
  background-color: ${({ theme }) => theme.colors.accentLight};
  padding: 0.6rem 1.2rem;
  border-radius: 999rem;
  margin-bottom: 1.6rem;
`;

export const Headline = styled.h2`
  font-size: 2.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin: 0 0 1rem;
  line-height: 1.2;

  ${MOBILE} {
    font-size: 2.2rem;
  }
`;

export const Sub = styled.p`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.5;
  max-width: 56rem;
  margin: 0 auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.6rem;

  ${MOBILE} {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
`;

export const Tile = styled.div<{ $featured?: boolean }>`
  grid-column: ${({ $featured }) => ($featured ? 'span 2' : 'auto')};
  background-color: ${({ theme, $featured }) =>
    $featured ? theme.colors.accentBgSoft : theme.colors.surfaceSoft};
  border: 0.1rem solid
    ${({ theme, $featured }) =>
      $featured ? theme.colors.accentBorder : theme.colors.border};
  border-radius: 1.6rem;
  padding: 2rem 1.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  transition:
    border-color 0.15s ease,
    transform 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.accent};
    transform: translateY(-0.2rem);
    box-shadow: 0 0.8rem 2rem rgba(14, 165, 233, 0.12);
  }

  ${MOBILE} {
    padding: 1.6rem 1.4rem;
  }
`;

export const TileIcon = styled.div`
  font-size: 2.6rem;
  line-height: 1;
`;

export const TileTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const TileDesc = styled.p`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.5;
  margin: 0;
`;
